// Drag-to-reorder geometry for a vertical list, kept free of the DOM so it can be tested.
// Positions are in one coordinate space (the list's own CSS px).

/**
 * The index a dragged row would land at: one slot past every OTHER row whose midpoint sits
 * above the dragged row's current center.
 *
 * @param {number[]} mids midpoint of each row, in list order, before the drag moved anything
 * @param {number} from the dragged row's index
 * @param {number} center the dragged row's current center
 * @returns {number}
 */
export function sortTargetIndex(mids, from, center) {
  let t = 0;
  for (let j = 0; j < mids.length; j++) {
    if (j !== from && mids[j] < center) t++;
  }
  return t;
}

/**
 * How far row `j` steps aside to open the gap at `to` while row `from` is dragged: one
 * row-and-gap (`step`) up or down for the rows the dragged one has passed, else 0.
 *
 * @param {number} j
 * @param {number} from
 * @param {number} to
 * @param {number} step
 * @returns {number}
 */
export function sortShift(j, from, to, step) {
  if (j === from) return 0;
  if (from < to && j > from && j <= to) return -step;
  if (to < from && j >= to && j < from) return step;
  return 0;
}
